import { useLingui } from '@lingui/react'
import { classNames } from 'app/functions'
import { useAppDispatch, useAppSelector } from 'app/state/hooks'
import React, { createContext, ReactNode, useContext, useMemo, useState } from 'react'

import {
  Box,
  Text,
  useColorMode,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalCloseButton,
  ModalBody,
} from '@chakra-ui/react'
import { Tabs, TabList, TabPanels, Tab, TabPanel } from '@chakra-ui/react'
import { selectOnsen, setOnsenModalView } from 'app/features/onsen/onsenSlice'

import { OnsenModalView } from './enum'
import InvestmentDetails from './InvestmentDetails'
import ManageBar from './ManageBar'
import ManageSwapPair from './ManageSwapPair'
import { useBurnActionHandlers } from 'app/state/burn/hooks'
import { Field } from 'app/state/burn/actions'

const COLUMN_CONTAINER = 'flex flex-col flex-grow gap-4'

interface FarmListItemDetailsModal {
  content: ReactNode
  setContent: React.Dispatch<React.SetStateAction<React.ReactNode>>
}

const Context = createContext<FarmListItemDetailsModal | undefined>(undefined)

// @ts-ignore TYPE NEEDS FIXING
const FarmListItemDetails = ({ farm }) => {
  const { i18n } = useLingui()
  const dispatch = useAppDispatch()
  const { view } = useAppSelector(selectOnsen)
  const [content, setContent] = useState<ReactNode>()
  const { colorMode, toggleColorMode } = useColorMode()
  const [isActive, setActive] = useState(false)
  const toggleClass = () => {
    setActive(!isActive)
  }

  const { onUserInput: _onUserInput } = useBurnActionHandlers()
  

  return (
    <Context.Provider value={useMemo(() => ({ content, setContent }), [content, setContent])}>
      <Box className="ligudity_in_bx">
        <ModalBody>
          <div className={classNames(COLUMN_CONTAINER, content ? '' : 'hidden')}>{content}</div>
          <div className={classNames(COLUMN_CONTAINER, content ? 'hidden' : '')}>
            <Box className="manage_txt_p_up">
              <Text>Manage Liquidity</Text>
              <ModalCloseButton onClick={e => _onUserInput(Field.LIQUIDITY, undefined)} />
            </Box>
            <Box className="tebs_main tebs_main_nil">
              <Tabs className="tow_tebs_manage" defaultIndex={view == OnsenModalView.Position ? 2 : 0}>
                <TabList className="teb_list">
                  <Tab
                    bg={'transparent'}
                    _selected={{ color: '#FFFFFF', bg: 'transparent' }}
                    className="staktab01 staktab01_as"
                  >
                    Liquidity
                  </Tab>
                  <Tab
                    bg={'transparent'}
                    _selected={{ color: '#FFFFFF', bg: 'transparent' }}
                    className="staktab02 staktab01_as"
                  >
                    Staking
                  </Tab>
                  <Tab
                    bg={'transparent'}
                    _selected={{ color: '#FFFFFF', bg: 'transparent' }}
                    className="staktab02 staktab01_as"
                  >
                    Rewards
                  </Tab>
                </TabList>
                <TabPanels className="liqudity_panl">
                  <TabPanel className="in_panel_liqudity">
                    <ManageSwapPair farm={farm} />
                  </TabPanel>
                  {/* staking_Tab_start         */}
                  <TabPanel className="in_panel_liqudity">
                    <ManageBar farm={farm} />
                  </TabPanel>
                  <TabPanel className="in_panel_liqudity">
                    <InvestmentDetails farm={farm} />
                  </TabPanel>
                </TabPanels>
              </Tabs>
            </Box>
          </div>
        </ModalBody>
      </Box>
    </Context.Provider>
  )
}

export const useFarmListItemDetailsModal = () => {
  const context = useContext(Context)
  if (!context) {
    // throw new Error('Hook can only be used inside Farm List Item Details Context')
  }

  return context
}

export default FarmListItemDetails
